/*! main.js | Adminuiux 2023-2024 */

/* ==========================================================================
Main initialization file
========================================================================== */

"use strict";

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

const rafThrottle = (fn) => {
    let running = false;
    return function () {
        if (running) return;
        running = true;
        requestAnimationFrame(() => {
            running = false;
            fn();
        });
    };
};

const debounce = (fn, wait = 150) => {
    let timer = null;
    return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => fn(), wait);
    };
};

const onScroll = rafThrottle(() => {
    activeHeader();
    scrolldirection();
    updateBackToTop();
});

const onResize = debounce(() => {
    fixedHeaderSpace();
    fixedFooterSpace();
    headerpaddingTop();
    adjustDataTable();
    syncSidebarModeOnResize();
});

window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', onResize);

document.addEventListener('DOMContentLoaded', () => {
    initSidebarState();
    setActivelink();
    fixedHeaderSpace();
    fixedFooterSpace();
    featherjs();
    dontclosedd();
    bstooltip();
    bspopover();
    bstoast();
    headerpaddingTop();
    selectable();
    initBackToTop();
    isinframe();
});

window.addEventListener('load', () => {
    coverimg();
    PageLoaderHide();
});
